import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import { useApi } from '~/lib/api/useApi';
import {
  IApiCreateInvitationRequestBody,
  IApiGetInvitationResponseBody,
} from '../InvitationsApi.types';
import { invitationQueryKeyFactory } from './useInvitationQuery';
import { organizationInvitationsQueryKeyFactory } from './useOrganizationInvitationsQuery';

export type IUseCreateInvitationMutationValues = {
  body: IApiCreateInvitationRequestBody;
};

export const useCreateInvitationMutation = (): UseMutationResult<
  IApiGetInvitationResponseBody,
  unknown,
  IUseCreateInvitationMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values: IUseCreateInvitationMutationValues) =>
      api.invitations.create(values.body),
    onSuccess: async (createdInvitation) => {
      await queryClient.invalidateQueries({
        queryKey: organizationInvitationsQueryKeyFactory({
          organizationId: createdInvitation.target.organizationId,
        }),
      });
      queryClient.setQueryData(
        invitationQueryKeyFactory({
          invitationId: createdInvitation._id,
        })!,
        createdInvitation,
      );
    },
  });
};
